export default [
  {
    "drugLabelName": "ABBOCATH-T WITH SYR 18GX1-1/4\"",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL 325 MG CAPLET",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL 325 MG LIQUID GEL",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL 325 MG TABLET",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL 500 MG CAPLET",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL 8 HOUR 650 MG CAPLET",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL 8 HOUR 650 MG GELTAB",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ALLERGY COMPLETE CPLT",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ALLERGY COMPLETE GELCP",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ALLERGY COMPLETE GELTB",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ALLERGY M-S CAPLET",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ALLERGY M-S NIGHT CPLT",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ALLERGY MULTI-SYMPTOM",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ALLERGY SINUS CAPLET",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ALLERGY SINUS CPLT",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ALLERGY SINUS GELCAP",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ALLERGY SINUS GELCP",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ALLERGY SINUS GELTAB",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ALLERGY SINUS GELTB",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ARTHRITIS CAPLET SA",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL ARTHRITIS ER 650 MG TB",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL CHEST CONGESTION CPLT",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL CHEST CONGESTION LIQ",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL CHILD 100 MG/ML DROPS",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL COLD & FLU MEDICINE",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL COLD & FLU PACKET",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL COLD & FLU SEVERE CPLT",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL COLD & FLU SEVERE LIQ",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL COLD CAPLET",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "TYLENOL COLD GELCAP",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "VITAMIN A PALM 15,000 UNIT TAB",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "VITAMIN A PALMITATE LIQUID",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "VITAMIN A TO Z TABLET",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "VITAMIN AND MINERAL TABLET",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "VITAMIN B-COMPLEX W/C VIAL",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "VITAMIN B-COMPLEX-100 VIAL",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "VITAMIN B-COMPLEX/C CAPLET",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "ZYRTEC-D ER 5 MG-120 MG TABLET",
    "hsn": null,
    "gsn": null
  },
  {
    "drugLabelName": "ZYVOX 600 MG/300 ML-D5W",
    "hsn": null,
    "gsn": null
  },
]
